/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_SubInputs */

const en_vc_onl_how_sub = /** @type {(inputs: Vc_Onl_How_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the real desktop app, compiled to WebAssembly. Here is what that means for you.`)
};

const zh_vc_onl_how_sub = /** @type {(inputs: Vc_Onl_How_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它就是桌面版应用，只是编译成了 WebAssembly。这对你意味着：`)
};

/**
* | output |
* | --- |
* | "It is the real desktop app, compiled to WebAssembly. Here is what that means for you." |
*
* @param {Vc_Onl_How_SubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_sub = /** @type {((inputs?: Vc_Onl_How_SubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_SubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_sub(inputs)
	return zh_vc_onl_how_sub(inputs)
});
export { vc_onl_how_sub as "vc.onl.how.sub" }